import GetTenantId from '/src/_includes/authentication/get-tenant-id.md';
import * as React from 'react';
export default {
  GetTenantId,
  React
};